import * as React from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

const textareaVariants = cva(
  cn(
    'flex min-h-[60px] w-full rounded-[8px] px-4 py-4 text-sm lg:text-base shadow-none placeholder:text-muted-foreground',
    'focus-visible:outline-none',
  ),
  {
    variants: {
      variant: {
        outlined: ['bg-white border border-border', 'ea-textarea__outlined'],
        filled: ['bg-white border-transparent', 'ea-textarea__filled'],
      },
      rounded: {
        default: 'rounded-[8px]',
        none: 'rounded-none',
      },
    },
    defaultVariants: {
      rounded: 'default',
      variant: 'outlined',
    },
  },
);

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  VariantProps<typeof textareaVariants> & {
    bottomBorder?: boolean;
    className?: string;
    classNames?: string;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, classNames, bottomBorder: _bottomBorder, variant, rounded, ...props }, ref) => {
    void _bottomBorder;

    return (
      <textarea
        style={{ resize: 'none' }}
        className={cn(
          textareaVariants({
            variant,
            rounded,
            className: cn(
              'ea-textarea bg-white',
              props['aria-invalid'] && 'ea-textarea--invalid border-destructive text-destructive',
              className,
              classNames,
            ),
          }),
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
